<template>
  <div v-if="unit">
    <b-row>
      <!-- Render the main unit type and name -->
      <b-col cols="12" md="6">
        <b-form-group
          class="text-sm my-1"
          :id="'input-group-unit'"
          :label="cleanUpText(unit.type)"
          :label-for="'input-unit'">
          <b-form-input
            class="form-text text-sm noFocus"
            type="text"
            disabled="true"
            :value="unit.name"
            required>
          </b-form-input>
        </b-form-group>
      </b-col>
      
      <!-- Render the children (parent hierarchy) types and names -->
      <template v-if="unit.children && unit.children.length">
        <b-col
          v-for="tree in (unit.children)"
          :key="tree.id"
          cols="12"
          md="6"
        >
          <b-form-group
            class="text-sm my-1"
            :id="'input-group-' + tree.id"
            :label="cleanUpText(tree.type)"
            :label-for="'input-' + tree.id">
            <b-form-input
              class="form-text text-sm noFocus"
              type="text"
              disabled="true"
              :value="tree.name"
              required>
            </b-form-input>
          </b-form-group>
        </b-col>
      </template>
    </b-row>
  </div>
  <div v-else class="text-center py-4 text-gray-500 text-sm">

    <p v-if="data.description"> Address : {{data.description}}</p>
  </div>
</template>

<script>
import axios from 'axios';

const STATIC_BEARER_TOKEN = '2ed561b0f3262056dc1f4329ddaaa081621a4b8e9e0cd9c3f5408e3b65204598.INn7fxhdpaE6Rqlmurpu7uoY6DxosThEFvLsaB/fqmdA9ee6nwIHFczPKFTTcakfcT/ZNOq5bSH08a7XMMK0e8ZrhHEtYdysQ0E6Rm6oLSMpqxkJwg==.W7krbw9c/z3DcPey';

export default {
  name: 'AdminUnitsView',
  props: {
    data: {
      type: Object,
      default: null,
    },
    api: {
      type: Object,
      default: null,
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      unit: null,
    };
  },
  watch: {
    data: {
      handler() {
        this.fetch();
      },
      deep: true,
    },
  },
  mounted() {
    if (this.data && this.data.villageId) this.fetch();
  },
  methods: {
    cleanUpText(name) {
      if (name) {
        let n = name.replaceAll("-", " ").replaceAll("_", " ").toLowerCase();
        return n.charAt(0).toUpperCase() + n.slice(1);
      }
      return "";
    },
    fetch() {
      var self = this;
      var villageId = this.data && this.data.villageId;
      if (!villageId) return;
      axios.get('https://api.das.staging.ursbonline.go.ug/admin-units/' + encodeURIComponent(villageId) + '?childrenLevels=7', {
        headers: {
          Authorization: 'Bearer ' + STATIC_BEARER_TOKEN,
        },
      })
        .then(function (res) {
          if (res.data && res.data.data) {
            self.unit = res.data.data;
          } else if (res.data) {
            self.unit = res.data;
          }
        })
        .catch(function () {
          self.unit = null;
        });
    },
  },
};
</script>

<style scoped>
</style>
